import { NavigateFunction, SetURLSearchParams } from "react-router-dom";
import { NavigateResponse } from "../../../../components/BrieChatMenu/GPTConvoTypes";

export function navigationCommand({
  message,
  navigate,
  setSearch,
}: {
  message: NavigateResponse;
  navigate: NavigateFunction;
  setSearch: SetURLSearchParams;
}) {
  if (message.URL.startsWith("?")) {
    setSearch(message.URL);
  } else {
    navigate(message.URL);
  }
}
